import axios from "axios";
import { getAppearance } from "./appearance";

const baseUrl = `${process.env.REACT_APP_API_IP}/api/v1/users`;

export const login = async (credentials) => {
  try {
    const res = await axios.post(baseUrl + "/login", credentials, {
      withCredentials: true,
    });
    // if (process.env.NODE_ENV === "development")
    document.cookie = "auth=" + res.data.token; // When in development cookie is set manually, because set-cookie doesn't work with SamSite: None and secure: false
    localStorage.setItem("user", JSON.stringify(res.data.data.user));
    await getAppearance();
  } catch (error) {
    return error.response.data.message;
  }
};

export const signup = async (credentials) => {
  try {
    const res = await axios.post(baseUrl + "/signup", credentials, {
      withCredentials: true,
    });
    // if (process.env.NODE_ENV === "development")
    document.cookie = "auth=" + res.data.token; // When in development cookie is set manually, because set-cookie doesn't work with SamSite: None and secure: false
    localStorage.setItem("user", JSON.stringify(res.data.data.user));
    await getAppearance();
  } catch (error) {
    return error.response.data.message;
  }
};

export const updateUser = async (updated, otherId) => {
  try {
    const userId = otherId || JSON.parse(localStorage.getItem("user"))._id;
    const res = await axios.patch(
      baseUrl + "/update/" + userId,
      { ...updated, accountChangedOn: Date.now() },
      {
        withCredentials: true,
      }
    );
    if (!otherId) {
      localStorage.setItem("user", JSON.stringify(res.data.data.updatedUser));
      return undefined;
    }
  } catch (error) {
    return error.response.data.message;
  }
};

export const sendResetPasswordLink = async (email) => {
  try {
    const res = await axios.post(baseUrl + "/forgotpassword", email, {
      withCredentials: true,
    });
  } catch (error) {
    return error.response.data.message;
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    const res = await axios.patch(
      baseUrl + "/resetpassword/" + token,
      newPassword,
      {
        withCredentials: true,
      }
    );
    // document.cookie = "auth=" + res.data.token; // When in development cookie is set manually, because set-cookie doesn't work with SamSite: None and secure: false
    // localStorage.setItem("user", JSON.stringify(res.data.user));
    // await getAppearance();
  } catch (error) {
    return error.response.data.message;
  }
};

export const verifyEmail = async (token) => {
  try {
    const res = await axios.patch(baseUrl + "/verify/" + token, {
      withCredentials: true,
    });
    return undefined;
  } catch (error) {
    console.log(error);
    return "failed";
  }
};
